import React from 'react';
import './StatCard.css';

interface StatCardProps {
  title: string;
  value: number;
  icon?: string;
  trend?: 'up' | 'down' | 'stable';
  color?: 'primary' | 'warning' | 'danger' | 'success';
}

export const StatCard: React.FC<StatCardProps> = ({ 
  title, 
  value, 
  icon, 
  trend, 
  color = 'primary' 
}) => {
  return (
    <div className={`stat-card stat-card--${color}`}>
      <div className="stat-card__header">
        {icon && <span className="stat-card__icon">{icon}</span>}
        <span className="stat-card__title">{title}</span>
      </div>
      <div className="stat-card__value">{value.toLocaleString()}</div>
      {trend && (
        <div className={`stat-card__trend stat-card__trend--${trend}`}>
          {trend === 'up' && '↑'}
          {trend === 'down' && '↓'}
          {trend === 'stable' && '→'}
        </div>
      )}
    </div>
  );
};
